import React from "react";

/**
 * Brand assets — Forte Capital
 * Escudo dourado com gráfico ascendente.
 * Use `<ForteShield />` quando precisar apenas do escudo (favicon, ícone mobile, sidebar compact).
 * Use `<ForteLogo />` para escudo + wordmark.
 */

export function ForteShield({ size = 32, className = "" }) {
  return (
    <svg
      viewBox="0 0 64 72"
      width={size}
      height={(size * 72) / 64}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Forte Capital"
      role="img"
    >
      <defs>
        <linearGradient id="fc-gold" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#F5D77A" />
          <stop offset="55%" stopColor="#D4AF37" />
          <stop offset="100%" stopColor="#8B6914" />
        </linearGradient>
        <linearGradient id="fc-gold-soft" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#1a1a1a" />
          <stop offset="100%" stopColor="#000" />
        </linearGradient>
      </defs>

      {/* Outer shield silhouette (gold) */}
      <path
        d="M32 1 L60 8 V36 C60 52 47 64 32 71 C17 64 4 52 4 36 V8 Z"
        fill="url(#fc-gold)"
      />
      {/* Inner shield (dark) — leaves a 2.5px golden border */}
      <path
        d="M32 5.2 L56.5 11.4 V35.7 C56.5 49.7 45.3 60.6 32 67.0 C18.7 60.6 7.5 49.7 7.5 35.7 V11.4 Z"
        fill="url(#fc-gold-soft)"
      />

      {/* Growth bars inside (ascending) */}
      <rect x="17" y="38" width="6" height="16" rx="1" fill="url(#fc-gold)" />
      <rect x="25.5" y="30" width="6" height="24" rx="1" fill="url(#fc-gold)" />
      <rect x="34" y="22" width="6" height="32" rx="1" fill="url(#fc-gold)" />
      <rect x="42.5" y="14" width="6" height="40" rx="1" fill="url(#fc-gold)" />

      {/* Top leaf (subtle) */}
      <path
        d="M32 8 C28.8 11.5 28.8 16.3 32 19.5 C35.2 16.3 35.2 11.5 32 8 Z"
        fill="url(#fc-gold)"
        opacity="0.85"
      />
    </svg>
  );
}

export function ForteLogo({
  size = 32,
  compact = false,
  subtitle = "Painel de Clientes",
  className = "",
}) {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <ForteShield size={size} />
      {!compact && (
        <div className="leading-tight">
          <div className="font-display font-bold tracking-[0.04em] text-white" style={{ fontSize: size * 0.5 }}>
            FORTE CAPITAL
          </div>
          {subtitle && (
            <div className="uppercase tracking-[0.22em] text-[#D4AF37]" style={{ fontSize: Math.max(9, size * 0.28) }}>
              {subtitle}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
